import { render, staticRenderFns } from "./PurchaseInvoicesListFiltersForm.vue?vue&type=template&id=2825bec0&scoped=true&"
import script from "./PurchaseInvoicesListFiltersForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicesListFiltersForm.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInvoicesListFiltersForm.vue?vue&type=style&index=0&id=2825bec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2825bec0",
  null
  
)

export default component.exports